/* JOBS_REFERRALS */
export const GET_JOBS_REFERRALS = "GET_JOBS_REFERRALS"
export const GET_JOBS_REFERRALS_SUCCESS = "GET_JOBS_REFERRALS_SUCCESS"
export const GET_JOBS_REFERRALS_FAIL = "GET_JOBS_REFERRALS_FAIL"
export const RESET_JOBS_REFERRALS = "RESET_JOBS_REFERRALS"


export const UPDATE_JOB_REFERRALS_LOADING_STATE = "UPDATE_JOB_REFERRALS_LOADING_STATE"

